import { useState } from "react";
import { STRIKE_CA } from "../lib/config";

/** The token contract address with a copy button. */
export function CaChip() {
  const [copied, setCopied] = useState(false);
  async function copy() {
    try {
      await navigator.clipboard.writeText(STRIKE_CA);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      /* clipboard blocked: the address is still selectable */
    }
  }
  return (
    <div className="ca-chip">
      <span className="ca-label mono">CA</span>
      <span className="ca-addr mono" title={STRIKE_CA}>
        <span className="ca-full">{STRIKE_CA}</span>
        <span className="ca-short">
          {STRIKE_CA.slice(0, 8)}…{STRIKE_CA.slice(-6)}
        </span>
      </span>
      <button className={`ca-copy ${copied ? "ok" : ""}`} onClick={copy} aria-label="Copy contract address">
        {copied ? (
          <svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true">
            <path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ) : (
          <svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true">
            <rect x="5" y="5" width="8.5" height="8.5" rx="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <path d="M10.5 5V3.5A1.5 1.5 0 0 0 9 2H3.5A1.5 1.5 0 0 0 2 3.5V9a1.5 1.5 0 0 0 1.5 1.5H5" fill="none" stroke="currentColor" strokeWidth="1.5" />
          </svg>
        )}
        <span>{copied ? "Copied" : "Copy"}</span>
      </button>
    </div>
  );
}
